module.exports = __webpack_public_path__ + "26edd9d52440940a25ff7946b15a3057.svg";